import { fetchDetailNF } from '@/api/business/cockpit'
import { useQuery } from '@tanstack/react-query'

export const DetailNFKeys = {
    all: ['detailnf'] as const,
    lists: () => [...DetailNFKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...DetailNFKeys.lists(), page, perPage, filters] as const,
    details: () => [...DetailNFKeys.all, 'detail'] as const,
    detail: (params: string) => [...DetailNFKeys.details(), params] as const,
}

export const useDetailNFQuery = (SK_NF: string) => {
    return useQuery({
        queryFn: () => fetchDetailNF({SK_NF}),
        queryKey: DetailNFKeys.detail(SK_NF),
    })
}
